import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import liracrypt from "../../components/Liracrypt/liracrypt";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import PerformanceGaugeGraph from "./Graph/PerformanceGaugeGraph";
import { getStyleProperties } from "../../utils/CustomFunc";
import SessionError from "../../components/ApiErrorComp/SessionError";
import MessageBox from "./MessageBox";
import MultiText from "../../components/MultiText";

const LeftContainer = ({
    lid,
    settings,
    Actual,
    settingValues,
    Diff,
    Rank,
    Target,
    mainG,
    mini,
    lineDashImageSrc,
    refreshLineDashboard
}) => {

    const [leftContainer, setLeftContainer] = useState(null);
    const [containerSettings, setContainerSettings] = useState();
    const [text1, setText1] = useState(null);
    const [text2, setText2] = useState(null);
    const [text3, setText3] = useState(null);
    const [text4, setText4] = useState(null);


    const [loginError, setLoginError] = useState(false);
    const [img, setImg] = useState(null);

    const refresh = useSelector((state) => state.refresh);

    const getData = () => {
        liracrypt
            .get("/cp/singleline", { lid: lid, pid: lineDashImageSrc })
            .then(({ data }) => {
                // dispatch({ type: "SET_LINE_IMG", payload: data.data["pid_011"] });
                let cacheImg = localStorage.getItem(`cache_img_${data.data[lineDashImageSrc]}`);
                if (cacheImg) {
                    setImg(cacheImg);
                    return;
                }
                liracrypt
                    .get("/imagecontrol", { _id: data.data[lineDashImageSrc] })
                    // .get("/linedashimage", { _id: data.data[lineDashImageSrc] })

                    .then((res) => {
                        if (res.status === 200) {
                            setImg(res.data.data);
                            localStorage.setItem(`cache_img_${data.data[lineDashImageSrc]}`, res.data.data);
                        } else {
                            let noImg = require(`../../assets/static/noImg.jpeg`);
                            setImg(noImg);
                            localStorage.setItem(`cache_img_${data.data[lineDashImageSrc]}`, noImg);
                        }
                    })
                    .catch((error) => {
                        console.log("Error****:", error);
                    });
            })
            .catch(function (error) {
                console.log("Error****:", error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    }

    useEffect(() => {
        getData();
        let interval = setInterval(() => {
            getData();
        }, 60000)
        return (() => clearInterval(interval))

    }, [refresh]);

    useEffect(() => {

        // if (settings && settingValues) {
        // console.log("LC");
        let microGraph = [];
        console.log(settingValues);
        setContainerSettings({ ...settingValues, ...settings });
        for (let i = 0; i < parseInt(settings.ld_main.microGuageQty); i++) {
            const key =
                i < 10 ? "ld_MicroGauge_0" + (i + 1) : "ld_MicroGauge_" + (i + 1);
            const settingKey =
                i < 10 ? "lD_MicroGauge_0" + (i + 1) : "lD_MicroGauge_" + (i + 1);
            if (settings.hasOwnProperty(key)) {
                microGraph.push({
                    text: settings[key].text,
                    text_style: getStyleProperties({ ...settings[key].legend }),
                    value:
                        (settingValues[settingKey] != null ||
                            settingValues[settingKey] != undefined) &&
                            settingValues[settingKey].toString().indexOf("%") >= 0
                            ? settingValues[settingKey].substr(
                                0,
                                settingValues[settingKey].indexOf("%")
                            )
                            : settingValues[settingKey],
                    value_style: getStyleProperties(settings[key].data),
                    graphColor: settings[key].axes,
                    numbeOfGraph: settings.ld_main.microGuageQty,
                    backgroundColor: settings[key]["background-color"],
                });
            }
        }
        let contentSettings = {
            performance: {
                title: {
                    text: settings.ld_ShiftPerf_Main.text,
                    style: getStyleProperties({
                        ...settings.ld_ShiftPerf_Main.legend,
                    }),
                },
                backgroundColor: settings.ld_ShiftPerf_Main["background-color"],
                target: {
                    text: settings.ld_ShiftPerf_Tgt.text,
                    text_style: getStyleProperties(settings.ld_ShiftPerf_Tgt.legend),
                    value: settingValues.lD_ShiftPerf_Tgt,
                    value_style: getStyleProperties(settings.ld_ShiftPerf_Tgt.data),
                },
                actual: {
                    text: settings.ld_ShiftPerf_Actual.text,
                    text_style: getStyleProperties(settings.ld_ShiftPerf_Actual.legend),
                    value: settingValues.lD_ShiftPerf_Actual,
                    value_style: getStyleProperties(settings.ld_ShiftPerf_Actual.data),
                },
                difference: {
                    text: settings.ld_ShiftPerf_Diff.text,
                    text_style: getStyleProperties(settings.ld_ShiftPerf_Diff.legend),
                    value: settingValues.lD_ShiftPerf_Diff,
                    value_style: getStyleProperties(settings.ld_ShiftPerf_Diff.data),
                },
                linerank: {
                    text: settings.ld_LineRank_Main.text,
                    text_style: getStyleProperties(settings.ld_LineRank_Main.legend),
                    value: settingValues.lD_LineRank_Main,
                    value_style: getStyleProperties(settings.ld_LineRank_Main.data),
                },
            },
            parts: {
                title: {
                    text: settings.ld_PartDet_Main.text,
                    style: getStyleProperties({
                        ...settings.ld_PartDet_Main.legend,
                    }),
                },
                backgroundColor: settings.ld_PartDet_Main["background-color"],
                product_no: {
                    value: settingValues.lD_PartDet_pno,
                    value_style: getStyleProperties(settings.ld_PartDet_Pno.data),
                },
                product_name: {
                    value: settingValues.lD_PartDet_Pname,
                    value_style: getStyleProperties(settings.ld_PartDet_Pname.data),
                },
                customer: {
                    value: settingValues.lD_PartDet_Cust,
                    value_style: getStyleProperties(settings.ld_PartDet_Cust.data),
                },
                currPartQty: {
                    value: settingValues.lD_CurrPartQty,
                    value_style: getStyleProperties(settings.ld_PartDet_Cust.data),
                },
            },
            mainGraph: {
                text: settings["ld_MainGauge"].text,
                text_style: getStyleProperties({
                    ...settings.ld_MainGauge.legend,
                }),
                value:
                    (settingValues["lD_MainGauge"] != null ||
                        settingValues["lD_MainGauge"] != undefined) &&
                        settingValues["lD_MainGauge"].toString().indexOf("%") >= 0
                        ? settingValues["lD_MainGauge"].substr(
                            0,
                            settingValues["lD_MainGauge"].indexOf("%")
                        )
                        : settingValues["lD_MainGauge"],
                value_style: getStyleProperties(settings.ld_MainGauge.data),
                graphColor: settings.ld_MainGauge.axes,
                numbeOfGraph: 1,
                backgroundColor: settings.ld_MainGauge["background-color"],
            },
            microGraph: microGraph,
        };
        setLeftContainer(contentSettings);
        // setTarget(contentSettings.performance.target.value);
        // setActual(contentSettings.performance.actual.value);
        // setDiff(contentSettings.performance.difference.value);
        // setRank(contentSettings.performance.linerank.value);
        setText1(contentSettings.parts.product_no.value);
        setText2(contentSettings.parts.product_name.value);
        setText3(contentSettings.parts.customer.value);
        setText4(contentSettings.parts.currPartQty.value);

        // console.log(Target, Diff, Actual, Rank);
    }, [settingValues]);

    const ImageV = () => {
        return (
            <div style={{ overflow: 'hidden', wordWrap: 'wrap' }}>
                {/* <div
                    style={{
                        padding: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                    }}
                >
                    <img
                        alt="image"
                        src={img ? img : require("../../images/noimg.png")}
                        style={{
                            border: 0,
                            boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                            borderRadius: "10px",
                            objectFit: "cover",
                            fontWeight: "600",
                            height: 150,
                            width: 'auto'
                        }}
                    />
                </div> */}
                <MultiText data={settingValues?.container2 || []} urlData={{ lid: lid }} />
                {/* <div style={leftContainer.parts.product_no.value_style}>{text1}</div>
                <div style={leftContainer.parts.product_name.value_style}>{text2}</div>
                <div style={leftContainer.parts.customer.value_style}>{"Customer: "}{text3}</div>
                <div style={leftContainer.parts.customer.value_style}>{"Current Qty: "}{text4}</div> */}
            </div>
        );
    };

    return (
        <React.Fragment>
            <SessionError visible={loginError} />
            {leftContainer !== null ? (
                <div>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} className="main-graph" style={{ padding: 10 }}>
                            <div
                                style={{
                                    backgroundColor: leftContainer.mainGraph.backgroundColor,
                                    border: 0,
                                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                                    borderRadius: "10px",
                                    fontWeight: "600",
                                }}
                                className="borderBox">
                                <div style={{}}>
                                    <PerformanceGaugeGraph
                                        height="130px"
                                        tsize="20px"
                                        graphSetting={{
                                            ...leftContainer.mainGraph,
                                            value: mainG,
                                        }}

                                        divId={"GuagePerform"}

                                    />
                                </div>
                                <div
                                    style={{
                                        textAlign: "center",
                                        padding: "5px",
                                        marginTop: "5px",
                                    }}
                                >
                                    <span style={leftContainer.mainGraph.text_style}>
                                        {leftContainer.mainGraph.text}
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} className="mini-graphs" style={{ padding: 5 }}>
                            <Row>
                                {leftContainer.microGraph.map((micro, ind) => {
                                    let loc = ind + 1;
                                    return (
                                        <Col
                                            lg={8} md={8} sm={12} xs={12}
                                            style={{ padding: 5 }}
                                            key={"micro" + ind}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: micro.backgroundColor,
                                                    border: 0,
                                                    boxShadow:
                                                        "5px 5px 9px #171717,-5px -5px 9px #232323",
                                                    borderRadius: "7px",
                                                    fontWeight: "600",
                                                }}
                                                className="borderBox"
                                            >
                                                <div>
                                                    <PerformanceGaugeGraph
                                                        height="45px"
                                                        graphSetting={{
                                                            ...micro,
                                                            value: mini["lD_MicroGauge_0" + loc],
                                                        }}
                                                        divId={"SubGuagePerform" + ind}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                        padding: "5px",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <span style={micro.text_style}>{micro.text}</span>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={24} sx={24} md={12} lg={12} style={{ padding: 10 }}>
                            <div
                                style={{
                                    backgroundColor: "rgb(29, 29, 29)",
                                    padding: "10px",
                                    height: "100%",
                                    border: 0,
                                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                                    borderRadius: "10px",
                                    fontWeight: "600",
                                }}
                                className="borderBox"
                            >
                                <MultiText data={settingValues?.container1 || []} urlData={{ lid: lid }} />
                                {/* <div className="LineContainer">
                                    <div>
                                        <p
                                            style={{
                                                ...leftContainer.performance.title.style,
                                                textAlign: "center",
                                            }}
                                        >
                                            {leftContainer.performance.title.text}
                                        </p>
                                    </div>
                                </div>

                                <div className="LineContainer1">
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span style={leftContainer.performance.target.text_style}>
                                            {leftContainer.performance.target.text}
                                        </span>
                                    </div>
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span
                                            style={leftContainer.performance.target.value_style}
                                        >
                                            {Target}
                                        </span>
                                    </div>
                                </div>
                                <div className="LineContainer1">
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span style={leftContainer.performance.target.text_style}>
                                            {leftContainer.performance.actual.text}
                                        </span>
                                    </div>
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span
                                            style={leftContainer.performance.target.value_style}
                                        >
                                            {Actual}
                                        </span>
                                    </div>
                                </div>
                                <div className="LineContainer1">
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span style={leftContainer.performance.target.text_style}>
                                            {leftContainer.performance.difference.text}
                                        </span>
                                    </div>
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span
                                            style={leftContainer.performance.target.value_style}
                                        >
                                            {Diff}
                                        </span>
                                    </div>
                                </div> */}
                                <Divider
                                    orientation="left"
                                    style={{
                                        color: "#3b3b3b",
                                        fontWeight: "normal",
                                        width: "3px",
                                    }}
                                ></Divider>
                                {/* <div
                                    style={{
                                        backgroundColor: "#212121",
                                        padding: "7px",
                                        marginTop: "10px",
                                        boxShadow:
                                            "inset 5px 5px 9px #171717,inset -5px -5px 9px #232323",
                                    }}
                                >
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span style={leftContainer.performance.target.text_style}>
                                            {leftContainer.performance.linerank.text}
                                        </span>
                                    </div>
                                    <div
                                        className="middleAlign"
                                        style={{ textAlign: "center" }}
                                    >
                                        <span
                                            style={leftContainer.performance.target.value_style}
                                        >
                                            {Rank}
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                        </Col>
                        <Col sm={24} sx={24} md={12} lg={12} style={{ padding: 10 }}>
                            <div
                                style={{
                                    backgroundColor: "rgb(29, 29, 29)",
                                    padding: "10px",
                                    height: "100%",
                                    border: 0,
                                    // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                                    boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                                    borderRadius: "10px",

                                    fontWeight: "600",
                                }}
                                className="borderBox"
                            >
                                {/* <div style={leftContainer.parts.title.style}>
                                    {leftContainer.parts.title.text}
                                </div> */}
                                <ImageV />
                            </div>
                        </Col>
                    </Row>
                    {
                        settings?.messageBox?.visible ?
                            <Row>
                                <Col sm={24} sx={24} md={24} lg={24} style={{ padding: 10 }}>
                                    <MessageBox selectedLid={lid} refreshLineDashboard={refreshLineDashboard} />
                                </Col>
                            </Row> : <></>
                    }
                </div>
            ) : null}
        </React.Fragment>
    );
};
export default LeftContainer;
